import { useMutation } from 'react-query'
import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { uploadDocument } from '@dc-shared-web/hooks/api/document/uploadDocument'
import type { UploadDocumentParams } from '@dc-shared-web/hooks/api/document/uploadDocument'

export const useUploadDocument = () => {
  const svcCrunchApiClient = useSvcCrunchesContext()

  return useMutation(async (formData: UploadDocumentParams) => {
    return await uploadDocument(svcCrunchApiClient, formData)
  })
}
